<template>
  <v-app>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <base-card
            title="Employee Kpi Assignment List"
            :v-card-text-class="'pa-0'"

                        :loading-allowed="false"
                    >
<v-row class="align-center py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                        >CSV</v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                        >EXCEL</v-btn>

                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                        >PDF</v-btn>

                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/master-data/assign-employee-kpi')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Assign Employee Kpi Assign
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                        <template v-slot:loader>
                            <v-progress-linear
                                :color="loading"
                                height="3"
                                indeterminate
                            />
                        </template>
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      class="me-2 edit-button"
                      color="primary"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath)"
                    >
                      mdi mdi-pencil-outline
                    </v-icon>
                  </template>
                </v-data-table>
          </base-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import BaseCard from '@/components/utils/baseCard.vue';
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";

export default {
  components: {
        BaseCard,},
  data: () => ({
    itemsPerPage: 10,
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "100px", sortable: false },
      { title: "Code", key: "code", align: "left", sortable: false, width: "100px" },
      { title: "Name", key: "name", align: "left", sortable: false, width: "350px" },
      { title: "Total KPI", align: "end", key: "kpi_details_count", sortable: true },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {
    const promises = [];
    promises.push(this.$store.dispatch("getHrmEmployeeList"));
    // if (this.$store.getters.getProductTypeList.length == 0) {
      promises.push(this.$store.dispatch("getProductTypeList"));
    // }
    // if (this.$store.getters.getCategoryList.length == 0) {
      promises.push(this.$store.dispatch("getCategoryList"));
    // }
    // if (this.$store.getters.getSubCategoryList.length == 0) {
      promises.push(this.$store.dispatch("getSubCategoryList"));
    // }

  },
  computed: {
    getSchema() {
      return this.$store.getters.getHrmEmployeeList;
    },
    getProductTypeList() {
      let data = this.$store.getters.getProductTypeList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getCategoryList() {
      let data = this.$store.getters.getCategoryList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getSubCategoryList() {
      let data = this.$store.getters.getSubCategoryList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // Add validation if needed
        // product_type: yup.number().positive().integer().nullable().label('Product Type'),
        // category: yup.number().positive().integer().nullable().label('Category'),
        // sub_category: yup.number().positive().integer().nullable().label('Sub Category'),
      }),
    });

    const product_type = useField("product_type");
    const category = useField("category");
    const sub_category = useField("sub_category");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();

    const submit = handleSubmit((values) => {
      loading.value = 'blue-darken-3';
      store
        .dispatch("getHrmEmployeeList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response.data.message);
        });
    });

    return {
      product_type,
      category,
      sub_category,
      submit,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },

    editItem(item) {
      this.$store.commit("SET_EDITING_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST", item);
      this.$router.push({ name: "assign-employee-kpi", query: {id: item.id} });
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Code", "Name", "Brand", "Category", "Sub Category", "Type", "Size", "Unit", "Model", "Purchase Rate", "Sale Rate", "Tax", "Weight", "Status", ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.name, item.brand?.name, item.category?.name, item.subcategory?.name, item.type?.name, item.size?.name, item.unit?.name, item.model, item.purchase_rate, item.sale_rate, item.tax, item.weight, item.status == 1 ? "Active" : "Inactive", ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Product List",
        "hrm_employee_kpi_record_" + this.$fileDate()
      );
    },

    exportToExcel() {
      var data = [[ "#SL", "Code", "Name", "Brand", "Category", "Sub Category", "Type", "Size", "Unit", "Model", "Purchase Rate", "Sale Rate", "Tax", "Weight", "Status", ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.name, item.brand?.name, item.category?.name, item.subcategory?.name, item.type?.name, item.size?.name, item.unit?.name, item.model, item.purchase_rate, item.sale_rate, item.tax, item.weight, item.status == 1 ? "Active" : "Inactive", ]);
      });
      this.$exportTableToExcel(data, "hrm_employee_kpi_record_" + this.$fileDate());
    },

    exportToCSV() {
      var data = [[ "#SL", "Code", "Name", "Brand", "Category", "Sub Category", "Type", "Size", "Unit", "Model", "Purchase Rate", "Sale Rate", "Tax", "Weight", "Status", ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.name, item.code, item.brand?.name, item.category?.name, item.subcategory?.name, item.type?.name, item.size?.name, item.unit?.name, item.model, item.purchase_rate, item.sale_rate, item.tax, item.weight, item.status == 1 ? "Active" : "Inactive", ]);
      });

      this.$exportTableToCSV(data, "hrm_employee_kpi_record_" + this.$fileDate());
    },
  },
  mounted() {

    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
